
import loadable from "@loadable/component";
import React, { useState } from "react";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../constant/EndPoint";
import Spinner from "../../components/Reusable/Spinner";
import usePatchHook from "../../customHooks/usePatchHook";
const OverViewComponent = loadable(
  () => import("../../components/Finance/Overview")
);

export const Overview = () => {
  const [selectedItem, setSelectedItem] = useState<any>(null)
  const [openEditPopup, setOpenEditPopup] = useState(false)
  const [defaultValue, setDefaultValue] = useState<any>([])


  const handleEditStatusChange = (value: any) => {
    setDefaultValue(value)
  };


  const { data: gridData, refetch, isLoading } = useGetHook({
    queryKey: [`grid-data`],
    url: `${APIS.GRID_REPORT_DATA}`,
    params: {},
  });

  const { data: statusList, } = useGetHook({
    queryKey: [`status`],
    url: `${APIS.STATUS}`,
    params: {
      is_active:true
    },
  });


  const { mutateAsync, isLoading: patchLoading } = usePatchHook({
    queryKey: ["grid-data"],
    navigateURL: "",
  });


  const handleStatusInclude = async (event: any) => {
    event.preventDefault()
    const url = `${APIS.GRID_REPORT_DATA}${selectedItem?.id}/`;
    let formData = {
      status: defaultValue?.map((item: any) => (item.id)) ?? []
    };
    try {
      const rest = await mutateAsync({ url, formData });
      if (rest.status === 200) {
        setOpenEditPopup(false)
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleOpenEditPopup = (item: any) => {
    setSelectedItem(item)
    setDefaultValue(item?.status)
    setOpenEditPopup(true)
  }


  return (
    <>{isLoading ? <Spinner /> :
      <OverViewComponent
        refetch={refetch}
        gridData={gridData}
        statusList={statusList}
        patchLoading={patchLoading}
        handleStatusInclude={handleStatusInclude}
        setSelectedItem={setSelectedItem}
        setOpenEditPopup={setOpenEditPopup}
        openEditPopup={openEditPopup}
        handleEditStatusChange={handleEditStatusChange}
        defaultValue={defaultValue}
        setDefaultValue={setDefaultValue}
        handleOpenEditPopup={handleOpenEditPopup}
      />
    }
    </>
  );
};
